import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "动作·科幻·悬疑·文艺",
    color: "bg-primary-600",
    ring: "group-hover:border-primary-400",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "古装·都市·谍战·海外剧",
    color: "bg-secondary-600",
    ring: "group-hover:border-secondary-400",
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    title: "综艺",
    desc: "真人秀·音乐·竞技·访谈",
    color: "bg-accent-500",
    ring: "group-hover:border-accent-400",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className={`group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:bg-background-100 ${entry.ring} md:p-5`}
          >
            <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${entry.color} text-background-50`}>
              <i className={`${entry.icon} text-2xl`} />
            </span>
            <span className="flex-1">
              <span className="block font-heading text-base font-bold text-foreground-950">
                {entry.title}
              </span>
              <span className="mt-0.5 block text-xs text-foreground-500">{entry.desc}</span>
            </span>
            <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </section>
  );
}